'use strict';
var React = require('react');
var i18n = require('../helper/i18n');

module.exports = React.createClass({
  render: function () {
    return (
      <div className="remote-preview-help">
        <p>
          {i18n.get('REMOTE_1')} <a href="index.html">{i18n.get('REMOTE_2')} index.html</a>{i18n.get('REMOTE_3')}
        </p>
        <p>
          {i18n.get('REMOTE_4')} <a href="README.txt">README.txt</a>{i18n.get('REMOTE_3')}
        </p>
        </div>
    );
  }
});


/** WEBPACK FOOTER **
 ** ./src/views/RemotePreviewHelp.jsx
 **/